import Vue from 'vue'
import VueProgressiveImage from 'vue-progressive-image'

Vue.use(VueProgressiveImage, {
  blur: 15
})


// WEBPACK FOOTER //
// ./resources/js/plugins/progressive-img.js